import React from "react";
import { useNav } from "../hooks/useNav";
import { ProjectCard } from "./ProjectCard";
import fastRadiusImg from "../utils/fast-radius.png";
import kalderosImg from "../utils/kalderos.png";
//import fallingImg from '../utils/fallingforwords.png';
//import getDataImg from '../utils/getdataquick.png';
import appLogo from "../utils/applogo87.png";
import reactLogo from "../utils/react.png";

const projects = [
	// {
	// 	projectName: "GetDataQuick",
	// 	projectImg: getDataImg,
	// 	projectDesc: ["React/Vite Typescript", "Python", "PostgreSQL / Supabase"],
	// 	buttonText: "Site link",
	// 	projectLink: "https://getdataquick.com",
	// 	projectNote:
	// 		"This SaaS product can be used to extract data from various sources quickly and efficiently in a structured format.",
	// },
	// {
	// 	projectName: "FallingForWords",
	// 	projectImg: fallingImg,
	// 	projectDesc: ["React/Pixi.js", "Supabase"],
	// 	buttonText: "Site link",
	// 	projectLink: "https://fallingforwords.com",
	// 	projectNote:
	// 		"This application is for storing media suggestions and allowing you to pick a random item from your list as well as use ai to help find you something to watch. On the app store now!",
	// },
	{
		projectName: "Fast Radius Portals",
		projectImg: fastRadiusImg,
		projectDesc: [
			"Supplier Portal",
			"Customer Portal",
			"Shared UI Repo",
			"SAAS/Billing",
		],
		buttonText: "portal link",
		projectLink: "https://os.fastradius.com/",
		projectNote:
			"Account creation is required to access the use of the portal. Free sign up with minimal information required.",
	},
	{
		projectName: "Verify",
		projectImg: kalderosImg,
		projectDesc: ["Verify Portal", "Automation for DS Team"],
		buttonText: "verify desc link",
		projectLink: "https://www.kalderos.com/tools/verify",
		projectNote:
			"This link is to a product description. In order to sign up for this platform you would need to be a drug manufacturer.",
	},
	{
		projectName: "Now: Playing",
		projectImg: appLogo,
		projectDesc: ["React Native", "Node.js", "PostgreSQL / Supabase"],
		buttonText: "App store link",
		projectLink: "https://apps.apple.com/us/app/now-playing/id6797100506",
		projectNote:
			"Track what you want to watch, rate everything you finish, and settle 'what should we watch?' for good — with your friends' taste right there next to yours.",
	},
	// {
	// 	projectName: "Design System",
	// 	projectImg: reactLogo,
	// 	projectDesc: ["Reusable components", "React Native/Typescript", "npm - package"],
	// 	projectNote:
	// 		"You can find and use the components from this package via npm by searching @browntreebear/reactnativesharedui",
	// },
];

export const Projects = () => {
	const projectsRef = useNav("Projects");

	return (
		<section
			className="flex w-full overflow-y-hidden h-screen"
			ref={projectsRef}
			id="projectsContainer"
		>
			<div className="text-coolGray-300 h-full w-10/12 m-auto">
				<div className="mb-8 text-4xl text-coolGray-100 pl-4 max-[690px]:text-center max-[690px]:pl-0">
					Projects
				</div>
				<div className="grid grid-cols-1 max-[700px]:grid-cols-2 sm:grid-cols-2 xl:grid-cols-3 gap-4 auto-rows-fr">
					{projects.map((p) => (
						<ProjectCard key={p.projectName} {...p} />
					))}
				</div>

			</div>
		</section>
	);
};

export default Projects;
